import React, {useEffect, useState} from 'react'
import {Col, Image, Input, Row, Space, Spin, Switch, Transfer, Typography} from "antd";
import {sanity_s3_url_display} from "../Utils";
import HttpError from "./HttpError";
import ArtworkFiltersPanel from "../piece/ArtworkFiltersPanel";
import ArtworkSortButton from "../piece/ArtworkSortButton";
import MyPagination from "../MyPagination";

const {Title, Text} = Typography

const DEFAULT_PAGE_SIZE = 12

function ArtworkSelectionPanel(props) {
    const [loading, setLoading] = useState(false)
    const [pageSize, setPageSize] = useState(DEFAULT_PAGE_SIZE)
    const [pageSizeRight, setPageSizeRight] = useState(DEFAULT_PAGE_SIZE)
    const [total, setTotal] = useState(0)
    const [totalRight, setTotalRight] = useState(0)
    const [current, setCurrent] = useState(1)
    const [currentRight, setCurrentRight] = useState(1)

    const [order, setOrder] = useState('-created_at')
    const [filters, setFilter] = useState(null)
    const [search, setSearch] = useState(null)
    const [dataSource, setDataSource] = useState([])
    const [targetKeys, setTargetKeys] = useState([])
    const [selectedKeys, setSelectedKeys] = useState([])
    const [showImage, setShowImage] = useState(true)

    function updateData() {
        setLoading(true)
        props
            .requestData(current, pageSize, order, filters, search)
            .then((response) => {
                let data = []
                response.data.results.forEach((artwork) => {
                    data.push({
                        key: artwork.id,
                        name: artwork.name,
                        src: artwork.static_url,
                        thumbnail: artwork.static_url,
                        s3_url: artwork.s3_url,
                        static_url: artwork.static_url
                    })
                })

                setLoading(false)
                setDataSource(data)
                setTotal(response.data.count)

                if (props.onDataSourceChange) {
                    props.onDataSourceChange(data)
                }
            })
            .catch((error) => {
                HttpError(error)
            }).finally(() => {
            setLoading(false)
        })
    }

    useEffect(() => {
        setPageSize(props.pageSize ?? DEFAULT_PAGE_SIZE)
        setDataSource(props.dataSource ?? [])
        setTargetKeys(props.targetKeys ?? [])
        setSelectedKeys(props.selectedKeys ?? [])
    }, [])

    useEffect(() => {
        setTargetKeys(props.initTargetKeys ?? [])
    }, [props.initTargetKeys])

    useEffect(() => {
        updateData()
    }, [current, pageSize, order, filters, search])

    function bottomLeftPagination() {
        function onPaginationChange(page) {
            setCurrent(page)
        }

        function onShowSizeChange(current, pageSize) {
            setCurrent(1)
            setPageSize(pageSize)
        }

        return (
            <>
                <Row justify='center' style={{padding: 12, margin: 12}}>
                    <MyPagination
                        showQuickJumper
                        showSizeChanger={true}
                        total={total}
                        current={current}
                        defaultPageSize={pageSize}
                        pageSize={pageSize}
                        showTotal={(total) => `Total ${total} items`}
                        onChange={onPaginationChange}
                        onShowSizeChange={onShowSizeChange}
                    />
                </Row>
            </>
        )
    }

    function bottomRightPagination() {
        function onPaginationChange(page) {
            setCurrentRight(page)
        }

        function onShowSizeChange(current, pageSize) {
            setCurrentRight(1)
            setPageSizeRight(pageSize)
        }

        return (
            <>
                <Row justify='center' style={{padding: 12, margin: 12}}>
                    <MyPagination
                        showQuickJumper
                        showSizeChanger={true}
                        total={targetKeys.length}
                        current={currentRight}
                        defaultPageSize={pageSizeRight}
                        pageSize={pageSizeRight}
                        showTotal={(total) => `Total ${total} items`}
                        onChange={onPaginationChange}
                        onShowSizeChange={onShowSizeChange}
                    />
                </Row>
            </>
        )
    }

    return (
        <Spin spinning={loading}>
            <Row>
                <Col style={{margin: 12, marginLeft: 24, display: 'flex', flexDirection: 'row', gap: 4}}>
                    <Title level={3}>
                        Select Artworks
                    </Title>
                </Col>
            </Row>
            <Row>
                <Col span={24} style={{paddingLeft: 24, paddingTop: 6, paddingBottom: 6}}>
                    <ArtworkFiltersPanel artistId={props.artistId} updateData={(state) => {
                        setFilter({
                            ...state
                        })
                    }}/>
                </Col>
                <Col span={24} style={{paddingLeft: 24, marginTop: 12}}>
                    <Space align="center" style={{flexWrap: 'wrap'}}>

                        <ArtworkSortButton order={order} onChange={(value) => {
                            setOrder(value)
                        }}/>
                        <Input.Search
                            style={{paddingTop: 16, minWidth: 320}}
                            placeholder='Piece Search'
                            onSearch={(value) => {
                                setSearch(value)
                                setCurrent(1)
                            }}
                        />
                        <div>
                            <span style={{marginLeft: 24, marginTop: 4}}>image: </span>
                            <Switch
                                onChange={(e) => {
                                    setShowImage(e)
                                }}
                                checkedChildren='On'
                                unCheckedChildren='Off'
                                checked={showImage}
                            />
                        </div>
                    </Space>
                </Col>

                <Col span={24}>
                    <span style={{
                        marginLeft: 24, marginTop: 12, fontSize: 10, color: 'grey',
                        minWidth: 360, paddingTop: 12, display: 'block',
                        width: '100%',
                        maxWidth: '94%'
                    }}>Click select to transfer the selected artworks from the 'Pieces' panel to the 'Pieces in Collection' panel.</span>
                    <Transfer
                        style={{padding: '1rem', width: '100%', flexWrap: 'wrap', minHeight: 640}}
                        dataSource={dataSource}
                        targetKeys={targetKeys}
                        selectedKeys={selectedKeys}
                        operationStyle={{
                            display: 'flex', fontSize: 24
                        }}
                        operations={['Select', 'Unselect']}
                        listStyle={{
                            width: '40%',
                            minWidth: 360,
                            maxWidth: '94%',
                            height: 'calc(100vh - 100px)',
                            maxHeight: 640,
                            overflow: 'auto'
                        }}
                        showSearch
                        render={(item) => (
                            <Row gutter={[12, 12]}>
                                <Col span={9} style={{height: 96}}>
                                    {showImage && (
                                        <Image
                                            src={showImage && sanity_s3_url_display(item.static_url)}
                                            preview={{
                                                src: sanity_s3_url_display(item.s3_url)
                                            }}
                                            style={{maxHeight: '160px', maxWidth: '160px'}}
                                        />
                                    )}
                                </Col>
                                <Col span={15} style={{height: 96, textOverflow: 'ellipsis', wordBreak: 'break-all'}}>
                                    #sku: {item.key} <br/> {item.name}
                                </Col>
                            </Row>
                        )}
                        titles={['Pieces', 'Pieces in Collection']}
                        selectAllLabels={[
                            ({selectedCount, totalCount}) => (
                                <span>
                              {selectedCount > 0 ? selectedCount + ' of' : null} {totalCount} piece{totalCount > 1 ? 's' : null}
                            </span>
                            ),
                            ({selectedCount, totalCount}) => (
                                <span>
                              {selectedCount > 0 ? selectedCount + ' of' : null} {totalCount} piece{totalCount > 1 ? 's' : null}
                            </span>
                            )
                        ]}
                        onChange={(nextTargetKeys, direction, moveKeys) => {
                            setTargetKeys(nextTargetKeys)
                            if (props.onTargetKeysChange)
                                props.onTargetKeysChange(nextTargetKeys)
                        }}
                        onSelectChange={(sourceSelectedKeys, targetSelectedKeys) => {
                            setSelectedKeys([...sourceSelectedKeys, ...targetSelectedKeys])
                        }}
                        filterOption={(inputValue, option) => {
                            let nameEqual = option.name.toLowerCase().includes(inputValue.toLowerCase())
                            let numEqual = option.key.toString().match(inputValue)
                            return nameEqual || numEqual
                        }}
                        footer={
                            (props, {direction}) => {
                                if (direction === 'left') return bottomLeftPagination()
                                return bottomRightPagination()
                            }
                        }
                    />
                </Col>
            </Row>
        </Spin>
    )
}

export default ArtworkSelectionPanel

ArtworkSelectionPanel.defaultProps = {}

ArtworkSelectionPanel.propTypes = {}